import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { borderRadius, borderWidth } from "../../../design-system/tokens/borders";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing[2]};
  padding: ${spacing[2]} ${spacing[3]};
  background-color: ${rawColors.structural[100]};
  border: ${borderWidth[1]} solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.md};
`;

export const PathLabel = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
  min-width: 0;
`;

export const TableName = styled.span`
  color: ${rawColors.text.highEmphasis};
`;

export const FocusLinkButton = styled.button`
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  text-align: inherit;
  color: inherit;
  font: inherit;

  &:hover ${TableName} {
    text-decoration: underline;
    color: ${rawColors.primary[500]};
  }

  &:focus-visible {
    outline: 2px solid ${rawColors.primary[500]};
    outline-offset: 2px;
    border-radius: ${borderRadius.sm};
  }
`;

export const Arrow = styled.span`
  color: ${rawColors.primary[500]};
  margin: 0 ${spacing[1]};
`;

export const TargetName = styled.span`
  color: ${rawColors.text.highEmphasis};
`;

export const ExternalLinkButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${rawColors.primary[500]};
  text-decoration: none;

  &:hover {
    opacity: 0.8;
  }
`;
